import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import Icon from 'src/components/Icon/Icon';
import { observer } from 'src/utils/mobx-react';
import { SortType } from './TradingEventsList.state';
import styled from '@emotion/styled';

const Select = styled('select', { label: 'Select' })`
    outline: none;
`;

export type LabelsType = 'h' | 'd' | 'a' | 'betsAfterStart' | 'off' | 'bip' | 'display' | 'status';

export interface TabMenuItemType {
    key: LabelsType,
    name: string,
    sort: SortType | undefined,
    definition: ((eventId: number) => React.ReactElement),
}

interface ItemPropsType {
    eventId: number
}

const ItemBetsAfterStart = observer('ItemBetsAfterStart', (props: ItemPropsType) => {
    const appState = useAppStateContext();
    const eventId = props.eventId;
    const eventModel = appState.sdkStaff.models.getEvent(eventId);

    if (eventModel === null) {
        return null;
    }

    const value = eventModel.timeSettingsTradedInPlay;
    const handler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        appState.sdkStaff.updateEvent({event_id: eventId, requestBody: {
            timeSettings: {
                tradedInPlay: e.target.value === '1'
            }
        }});
    };

    return (
        <div className='element'>
            <div className='select-wrapper'>
                <Select
                    value={ value ? '1' : '0' }
                    onChange={ handler }
                >
                    <option value='1'>Yes</option>
                    <option value='0'>No</option>
                </Select>
            </div>
        </div>
    );
});

const ItemOff = observer('ItemOff', (props: ItemPropsType) => {
    const appState = useAppStateContext();
    const eventId = props.eventId;
    const eventModel = appState.sdkStaff.models.getEvent(eventId);

    if (eventModel === null) {
        return null;
    }

    const started = eventModel.timeSettingsStarted;

    if (started) {
        return <Icon name='checkmark' />;
    }

    return <Icon name='exit' />;
});

const ItemBip = observer('ItemBip', (props: ItemPropsType) => {
    const appState = useAppStateContext();
    const eventId = props.eventId;
    const eventModel = appState.sdkStaff.models.getEvent(eventId);

    if (eventModel === null) {
        return null;
    }

    const tradedInPlay = eventModel.timeSettingsTradedInPlay;

    if (tradedInPlay) {
        return <Icon name='checkmark' />;
    }

    return <Icon name='exit' />;
});

const ItemDisplay = observer('ItemDisplay', (props: ItemPropsType) => {
    const appState = useAppStateContext();
    const eventId = props.eventId;
    const eventModel = appState.sdkStaff.models.getEvent(eventId);

    if (eventModel === null) {
        return null;
    }

    const value = eventModel.display;
    const handler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        appState.sdkStaff.updateEvent({event_id: eventId, requestBody: {
            display: e.target.value === '1'
        }});
    };

    return (
        <div className='element'>
            <div className='select-wrapper'>
                <Select
                    value={ value ? '1' : '0' }
                    onChange={ handler }
                    className={ value ? 'select--success' : 'select--error' }
                >
                    <option value='1'>On</option>
                    <option value='0'>Off</option>
                </Select>
            </div>
        </div>
    );
});

const ItemStatus = observer('ItemStatus', (props: ItemPropsType) => {
    const appState = useAppStateContext();
    const eventId = props.eventId;
    const eventModel = appState.sdkStaff.models.getEvent(eventId);

    if (eventModel === null) {
        return null;
    }

    const value = eventModel.active;
    const handler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        appState.sdkStaff.updateEvent({event_id: eventId, requestBody: {
            active: e.target.value === '1'
        }});
    };

    return (
        <div className='element'>
            <div className='select-wrapper'>
                <Select
                    value={ value ? '1' : '0' }
                    onChange={ handler }
                    className={ value ? 'select--success' : 'select--error' }
                >
                    <option value='1'>Active</option>
                    <option value='0'>Suspended</option>
                </Select>
            </div>
        </div>
    );
});


export const TABS: { prices: Array<TabMenuItemType>, details: Array<TabMenuItemType> } = {
    prices: [
        {
            key: 'h',
            name: 'H',
            sort: undefined,
            definition: (): React.ReactElement => <>3</>,
        }, {
            key: 'd',
            name: 'D',
            sort: undefined,
            definition: (): React.ReactElement => <>2</>,
        }, {
            key: 'a',
            name: 'A',
            sort: undefined,
            definition: (): React.ReactElement => <>1</>,
        }
    ],
    details: [
        {
            key: 'betsAfterStart',
            name: 'Bets after start',
            sort: undefined,
            definition: (eventId: number): React.ReactElement => <ItemBetsAfterStart eventId={eventId} />
        }, {
            key: 'off',
            name: 'Off',
            sort: undefined,
            definition: (eventId: number): React.ReactElement => <ItemOff eventId={eventId} />,
        }, {
            key: 'bip',
            name: 'BIP',
            sort: undefined,
            definition: (eventId: number): React.ReactElement => <ItemBip eventId={eventId} />,
        }, {
            key: 'display',
            name: 'Display',
            sort: undefined,
            definition: (eventId: number): React.ReactElement => <ItemDisplay eventId={eventId} />,
        }, {
            key: 'status',
            name: 'Status',
            sort: undefined,
            definition: (eventId: number): React.ReactElement => <ItemStatus eventId={eventId} />,
        }
    ]
};

